// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-old {
    display: none;
}

/* Responsive variable overrides (base values live in shared.css) */
@media (min-width: 576px) {
    #authentication.user-coordinator {
        --form-width: 360px;
        --card-padding: 30px;
        --form-wrapper-h-padding: 50px;
    }
}
@media (min-width: 768px) {
    #authentication.user-coordinator {
        --form-width: 320px;
    }
}
@media (min-width: 992px) {
    #authentication.user-coordinator {
        --form-width: 360px;
    }
}

/* Typography */
.small-print,
.small-print a {
    font-size: 14px;
    color: var(--lightest_legible_grey);
}

/* Page layout */
html {
    overflow: hidden;
}

.authentication-action {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 50%;
    padding: calc(var(--card-padding) + var(--lg_padding)) var(--card-padding);
}

#authentication.user-coordinator {
    display: flex;
    flex-direction: column;
    min-height: 100dvh;
}

#authentication.user-coordinator main {
    background: var(--ce-com-gradient);
}

@media (min-width: 768px) {
    #authentication.user-coordinator {
        height: 100dvh;
    }
}

/* Responsive form-wrapper override — narrows the card on wider screens */
@media (min-width: 576px) {
    #authentication.user-coordinator .form-wrapper {
        width: auto;
        margin-top: 50px;
        border-radius: var(--border_radius_lg);
        flex: initial;
    }
}

/* Form elements */
.rk-admin .combo-input-group .admin-input {
    flex: 1;
}

.editor-controls-button.text-button .plain-text {
    color: var(--lightest_legible_grey);
}
`, "",{"version":3,"sources":["webpack://./src/components/Authentication/Coordinator/authentication.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA,mEAAmE;AACnE;IACI;QACI,mBAAmB;QACnB,oBAAoB;QACpB,8BAA8B;IAClC;AACJ;AACA;IACI;QACI,mBAAmB;IACvB;AACJ;AACA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA,eAAe;AACf;;IAEI,eAAe;IACf,mCAAmC;AACvC;;AAEA,gBAAgB;AAChB;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,0EAA0E;AAC9E;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA,yEAAyE;AACzE;IACI;QACI,WAAW;QACX,gBAAgB;QAChB,sCAAsC;QACtC,aAAa;IACjB;AACJ;;AAEA,kBAAkB;AAClB;IACI,OAAO;AACX;;AAEA;IACI,mCAAmC;AACvC","sourcesContent":[".login-old {\n    display: none;\n}\n\n/* Responsive variable overrides (base values live in shared.css) */\n@media (min-width: 576px) {\n    #authentication.user-coordinator {\n        --form-width: 360px;\n        --card-padding: 30px;\n        --form-wrapper-h-padding: 50px;\n    }\n}\n@media (min-width: 768px) {\n    #authentication.user-coordinator {\n        --form-width: 320px;\n    }\n}\n@media (min-width: 992px) {\n    #authentication.user-coordinator {\n        --form-width: 360px;\n    }\n}\n\n/* Typography */\n.small-print,\n.small-print a {\n    font-size: 14px;\n    color: var(--lightest_legible_grey);\n}\n\n/* Page layout */\nhtml {\n    overflow: hidden;\n}\n\n.authentication-action {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    width: 50%;\n    padding: calc(var(--card-padding) + var(--lg_padding)) var(--card-padding);\n}\n\n#authentication.user-coordinator {\n    display: flex;\n    flex-direction: column;\n    min-height: 100dvh;\n}\n\n#authentication.user-coordinator main {\n    background: var(--ce-com-gradient);\n}\n\n@media (min-width: 768px) {\n    #authentication.user-coordinator {\n        height: 100dvh;\n    }\n}\n\n/* Responsive form-wrapper override — narrows the card on wider screens */\n@media (min-width: 576px) {\n    #authentication.user-coordinator .form-wrapper {\n        width: auto;\n        margin-top: 50px;\n        border-radius: var(--border_radius_lg);\n        flex: initial;\n    }\n}\n\n/* Form elements */\n.rk-admin .combo-input-group .admin-input {\n    flex: 1;\n}\n\n.editor-controls-button.text-button .plain-text {\n    color: var(--lightest_legible_grey);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
